
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class Adv05HdDialog extends Serenity.EntityDialog<Adv05HdRow, any> {
        protected getFormKey() { return Adv05HdForm.formKey; }
        protected getIdProperty() { return Adv05HdRow.idProperty; }
        protected getLocalTextPrefix() { return Adv05HdRow.localTextPrefix; }
        protected getNameProperty() { return Adv05HdRow.nameProperty; }
        protected getService() { return Adv05HdService.baseUrl; }
        protected getDeletePermission() { return Adv05HdRow.deletePermission; }
        protected getInsertPermission() { return Adv05HdRow.insertPermission; }
        protected getUpdatePermission() { return Adv05HdRow.updatePermission; }

        protected form = new Adv05HdForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }
    }
}